import { Box, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect } from "react";

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export const DealTileAd: React.FC = () => {
  const borderColor = useColorModeValue("gray.300", "gray.600");
  const bgColor = useColorModeValue("white", "gray.700");

  useEffect(() => {
    try {
      // Push the ad configuration to adsbygoogle array
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error("Error initializing AdSense ad:", error);
    }
  }, []);

  return (
    <Box
      className="ch-dealfinder-ad-tile"
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="xl"
      overflow="hidden"
      bg={bgColor}
      transition="all 0.3s"
      display="flex"
      flexDirection="column"
      position="relative"
      justifyContent="center"
      alignItems="center"
      p={2}
      _hover={{
        transform: "translateY(-2px)",
        shadow: "md",
      }}>
      <ins
        className="adsbygoogle"
        style={{
          display: "block",
          width: "250px",
          height: "395px",
        }}
        data-ad-format="fluid"
        data-ad-layout-key="-6o+cx+4r-i-6c"
        data-ad-client="ca-pub-9933699444769737"
        data-ad-slot="5653883361"
      />
    </Box>
  );
};
